/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/redux';

import { Stack, TextField } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { CustomButton, TextButton } from 'src/components';

import { loginReferrer, referFriendSelectors } from 'src/redux/referFriend';

export const ExternalSignIn: React.FC<{ onOtherOptionsClick: () => void }> = ({
  onOtherOptionsClick,
}) => {
  const dispatch = useAppDispatch();

  const isPerformingAction = useAppSelector(
    referFriendSelectors.getReferrerIsPerformingAction,
  );

  const [email, setEmail] = useState('');

  const onLoginClick = () => {
    dispatch(loginReferrer({ email }));
  };

  return (
    <Stack mt={4} gap={3}>
      <TextField
        name="email"
        type="email"
        placeholder="Email"
        label="Email"
        id="email"
        variant="outlined"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && email && onLoginClick()}
      />
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <CustomButton
          onClick={onLoginClick}
          isDisabled={!email}
          isLoading={isPerformingAction}
          label="Continue"
        />
        <TextButton
          variant="secondary"
          onClick={onOtherOptionsClick}
          startIcon={
            <ArrowBackIcon sx={{ color: '#FFB74D', fontSize: '16px' }} />
          }
        >
          Other options
        </TextButton>
      </Stack>
    </Stack>
  );
};
